import {UtilitiesService} from '../../services/utilities-service/utilities.service';
import {Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {Store} from '@ngxs/store';
import {NzModalRef, NzModalService} from 'ng-zorro-antd/modal';
import {IMedia} from '../../interfaces/cloudinary-transform';

@Component({
  selector: 'app-upload-files',
  templateUrl: './upload-files.component.html',
  styleUrls: ['./upload-files.component.scss']
})
export class UploadFilesComponent implements OnInit {
  @Input() files: IMedia[];
  @Input() loadingImage: boolean[];
  @Output() fileSelected: EventEmitter<{ file: File, index: number }> = new EventEmitter<{ file: File, index: number }>();
  @Output() deleteFile: EventEmitter<{ id: string, index: number }> = new EventEmitter<{ id: string, index: number }>();
  @ViewChild('tplModalDelete') tplModalDelete: TemplateRef<any>;

  confirmDeleteModal?: NzModalRef;

  constructor(
    private modal: NzModalService,
    private store: Store,
    private utilitiesService: UtilitiesService
  ) {
    this.initValues();
  }

  ngOnInit(): void {
  }

  initValues(): void {
    this.files = [];
    this.loadingImage = [];
  }

  onOpenFileExplorer(): void {
    document.getElementById('file').click();
  }

  onChangeFile($event: any): void {
    if ($event.target.files.length === 0) {
      // this.messageService.error('No se cargó ningún archivo');
      return;
    }
    const selectedFile = $event.target.files[0];
    if (!this.utilitiesService.validateExtensionImage(selectedFile)) {
      return;
    }
    // FileReader
    const reader = new FileReader();
    reader.onload = (evt: ProgressEvent<FileReader>) => {
      const media: IMedia = {
        assetId: '',
        extension: '',
        key: '',
        metadata: {},
        originalName: '',
        secureUrl: '',
        size: 0,
        tags: '',
        transformations: [],
        path: evt.target!.result!.toString(),
      }
      this.files.push(media);

      this.fileSelected.emit({ file: selectedFile as File, index: this.files.length - 1 });
    };
    reader.onerror = (evt: ProgressEvent<FileReader>) => {
      const errMsg = 'El archivo no se puede leer: ' + evt.target!.error!.code;
      // this.messageService.error(errMsg);
    };
    reader.readAsDataURL(selectedFile);
    // this.onChooseFile(selectedFile);
  }

  onDeleteFile(id: string, index: number): void {
    this.confirmDeleteModal = this.modal.confirm({
      nzTitle: 'Eliminar imagen',
      nzContent: this.tplModalDelete,
      nzOkText: 'ELIMINAR',
      nzCancelText: 'CANCELAR',
      nzOkDanger: true,
      nzClassName: 'modal-confirm',
      nzWidth: '500px',
      nzClosable: false,
      nzOnOk: async () => {
        this.deleteFile.emit({ id, index });
      },
      nzOnCancel: () => {

      },
    });
  }


  onClickFile(index: number): void {
    document.getElementById('fullImage' + index).click();
  }


}
